export interface TimelineEvent {
  id: string;
  year: string;
  company: { en: string; tr: string };
  role: { en: string; tr: string };
  duration: string;
  details: { en: string[]; tr: string[] };
  logo_url?: string;
}


export interface CuratedItem {
  id: string;
  title: { en: string; tr: string };
  subtitle: { en: string; tr: string };
  category: "music" | "books" | "films";
  link?: string;
}

export const socialLinks = [
  { name: "Github", url: "https://github.com/ugurcanuzunkaya", icon: "github", color: "hover:text-[#24292e] dark:hover:text-white" },
  { name: "Linkedin", url: "https://linkedin.com/in/ugurcanuzunkaya", icon: "linkedin", color: "hover:text-[#0a66c2]" },
  { name: "X", url: "https://x.com/ugurcanuznkaya", icon: "twitter", color: "hover:text-black dark:hover:text-white" },
  { name: "Medium", url: "https://medium.com/@ugurcanuzunkaya1", icon: "book-open", color: "hover:text-[#12100e] dark:hover:text-white" },
  { name: "Substack", url: "https://ugurcanuzunkaya.substack.com/", icon: "mail", color: "hover:text-[#ff6719]" },
  { name: "Youtube", url: "https://www.youtube.com/@benugurcanuzunkaya", icon: "youtube", color: "hover:text-[#ff0000]" },
  { name: "Linktree", url: "https://linktr.ee/ugurcanuzunkaya", icon: "link", color: "hover:text-[#39e09b]" },
  { name: "Instagram (TR)", url: "https://www.instagram.com/benugurcanuzunkaya/", icon: "instagram", color: "hover:text-[#e1306c]" },
  { name: "Instagram (EN)", url: "https://www.instagram.com/iamugurcanuzunkaya/", icon: "instagram", color: "hover:text-[#e1306c]" },
  { name: "Kick", url: "https://kick.com/ugurcanuzunkaya", icon: "twitch", color: "hover:text-[#53fc18]" },
  { name: "Club.com", url: "https://club.com/ugurcanuzunkaya", icon: "users", color: "hover:text-[#0057ba]" },
  { name: "Tiktok", url: "https://tiktok.com/@ugurcanuzunkaya", icon: "music", color: "hover:text-[#ff0050]" }
];

export const professionalTimeline: TimelineEvent[] = [
  {
    id: "reida",
    year: "2026",
    company: { en: "Reida Prints Shop", tr: "Reida Prints Shop" },
    role: { en: "Founder", tr: "Kurucu" },
    duration: "2026 - Still",
    details: {
      en: [
        "Launched a creative prints commerce shop showcasing art and design.",
        "Built and engineered the commerce architecture and automation systems."
      ],
      tr: [
        "Sanat ve tasarım ürünlerini sergileyen yaratıcı bir e-ticaret mağazası kuruldu.",
        "E-ticaret mimarisi ve otomasyon sistemleri tasarlandı ve geliştirildi."
      ]
    }
  },
  {
    id: "pipeline",
    year: "2026",
    company: { en: "Pipeline Partners", tr: "Pipeline Partners" },
    role: { en: "Co-Founder", tr: "Kurucu Ortak" },
    duration: "2026 - Still",
    details: {
      en: [
        "Co-founded a modern venture studio focused on accelerating AI development.",
        "Oversee technical execution and software delivery pipelines for portfolio startups."
      ],
      tr: [
        "Yapay zeka geliştirmelerini hızlandırmaya odaklanan modern bir girişim stüdyosu kuruldu.",
        "Portföy start-up'ları için teknik süreçler ve yazılım dağıtım altyapısı yönetiliyor."
      ]
    }
  },
  {
    id: "freelance",
    year: "2025",
    company: { en: "Freelance", tr: "Serbest Çalışan" },
    role: { en: "AI & Software Engineer", tr: "Yapay Zeka ve Yazılım Mühendisi" },
    duration: "2025 - Still",
    details: {
      en: [
        "Consulted international clients on integrating Generative AI into production systems.",
        "Designed and shipped bespoke web applications with modern frontend stacks."
      ],
      tr: [
        "Uluslararası müşterilere Üretken Yapay Zekanın üretim sistemlerine entegrasyonu konusunda danışmanlık verildi.",
        "Modern ön uç teknolojileri ile özel web uygulamaları tasarlandı ve yayına alındı."
      ]
    }
  },
  {
    id: "turkaicommunity",
    year: "2025",
    company: { en: "Turkish AI Community", tr: "Türkiye Yapay Zeka Topluluğu" },
    role: { en: "Head of Technology", tr: "Teknoloji Lideri" },
    duration: "2025 - Still",
    details: {
      en: [
        "Direct the technological infrastructure and platform roadmap for the community.",
        "Coordinate developer groups, hands-on workshops, and open-source packages."
      ],
      tr: [
        "Topluluğun teknolojik altyapısını ve platform yol haritasını yönetiyorum.",
        "Geliştirici gruplarını, uygulamalı atölyeleri ve açık kaynak kodlu paketleri koordine ediyorum."
      ]
    }
  },
  {
    id: "eleport-sr",
    year: "2024",
    company: { en: "ELEport", tr: "ELEport" },
    role: { en: "Senior R&D Engineer", tr: "Kıdemli Ar-Ge Mühendisi" },
    duration: "2024 - 2025",
    details: {
      en: [
        "Led R&D initiatives implementing machine learning algorithms for supply chain networks.",
        "Optimized logistics operations using data-driven scheduling heuristics."
      ],
      tr: [
        "Tedarik zinciri ağları için makine öğrenimi algoritmaları uygulayan Ar-Ge girişimlerine liderlik edildi.",
        "Veriye dayalı çizelgeleme sezgiselleri kullanarak lojistik operasyonları optimize edildi."
      ]
    }
  },
  {
    id: "eleport",
    year: "2022",
    company: { en: "ELEport", tr: "ELEport" },
    role: { en: "Software Engineer", tr: "Yazılım Mühendisi" },
    duration: "2022 - 2024",
    details: {
      en: [
        "Designed and developed full-stack web platforms using TypeScript and Node.js.",
        "Maintained high performance and clean test coverage across microservices."
      ],
      tr: [
        "TypeScript ve Node.js kullanarak uçtan uca web platformları tasarlandı ve geliştirildi.",
        "Mikro servisler genelinde yüksek performans ve temiz test kapsamı sürdürüldü."
      ]
    }
  }
];

export const academicTimeline: TimelineEvent[] = [
  {
    id: "phd",
    year: "2023",
    company: { en: "Eskisehir Technical University", tr: "Eskişehir Teknik Üniversitesi" },
    role: { en: "Doctorate Degree - Industrial Engineering", tr: "Doktora Derecesi - Endüstri Mühendisliği" },
    duration: "2023 - Still",
    details: {
      en: [
        "Pursuing a direct PhD program based on a Bachelor's Degree.",
        "Researching decision-making algorithms, operations research, and intelligent systems."
      ],
      tr: [
        "Lisans derecesine dayalı doğrudan doktora programına devam ediliyor.",
        "Karar verme algoritmaları, yöneylem araştırması ve akıllı sistemler üzerine araştırmalar yürütülüyor."
      ]
    }
  },
  {
    id: "bachelor",
    year: "2017",
    company: { en: "Eskisehir Technical University", tr: "Eskişehir Teknik Üniversitesi" },
    role: { en: "Bachelor's Degree - Industrial Engineering", tr: "Lisans Derecesi - Endüstri Mühendisliği" },
    duration: "2017 - 2022",
    details: {
      en: [
        "Graduated with honors in Industrial Engineering.",
        "Acquired strong foundations in data analysis, optimization, systems modeling, and simulation."
      ],
      tr: [
        "Endüstri Mühendisliği bölümünden başarıyla mezun olundu.",
        "Veri analizi, optimizasyon, sistem modelleme ve simülasyon konularında güçlü temeller kazanıldı."
      ]
    }
  }
];

export const communityTimeline: TimelineEvent[] = [
  {
    id: "comm-tech",
    year: "2026",
    company: { en: "AI Platforms Launch", tr: "Yapay Zeka Platformları" },
    role: { en: "Platform Development", tr: "Platform Geliştirme" },
    duration: "2026",
    details: {
      en: [
        "Launched open-source portals and libraries to support Turkish developer onboarding into AI.",
        "Developed custom API wrappers for regional LLM models."
      ],
      tr: [
        "Türk geliştiricilerin yapay zekaya katılımını desteklemek için açık kaynaklı portallar ve kütüphaneler yayına alındı.",
        "Bölgesel YDL (LLM) modelleri için özel API sarmalayıcıları geliştirildi."
      ]
    }
  },
  {
    id: "comm-meetups",
    year: "2025",
    company: { en: "Turkish AI Hackathons", tr: "Türkiye Yapay Zeka Hackathonları" },
    role: { en: "Head Organizer", tr: "Baş Organizatör" },
    duration: "2025",
    details: {
      en: [
        "Organized 3 national hackathons with over 1,000 active developer participants.",
        "Secured sponsorships and mentored teams on pitching AI startup models."
      ],
      tr: [
        "1.000'den fazla aktif geliştiricinin katıldığı 3 ulusal hackathon organize edildi.",
        "Sponsorluklar sağlandı ve ekiplere yapay zeka girişim modellerini sunmaları konusunda mentorluk yapıldı."
      ]
    }
  }
];

export { curatedList } from "./travelData";
